import React from 'react';
import PropTypes from 'prop-types';
import { Bar, Line, Doughnut } from 'react-chartjs-2';

const chartOptionsBase = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { display: true, position: 'bottom' },
  tooltips: { mode: 'index', intersect: false },
};

export const FuelBarChart = ({ labels, expected, real }) => {
  const data = {
    labels: labels || [],
    datasets: [
      {
        label: 'Esperado',
        backgroundColor: '#8bc1ff',
        data: expected || [],
      },
      {
        label: 'Real',
        backgroundColor: '#007bff',
        data: real || [],
      },
    ],
  };
  return (
    <div style={{ height: 245 }}>
      <Bar
        data={data}
        options={{
          ...chartOptionsBase,
          scales: {
            yAxes: [{ ticks: { beginAtZero: true } }],
          },
        }}
      />
    </div>
  );
};

FuelBarChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  expected: PropTypes.arrayOf(PropTypes.number),
  real: PropTypes.arrayOf(PropTypes.number),
};

FuelBarChart.defaultProps = {
  labels: [],
  expected: [],
  real: [],
};

export const FuelLineChart = ({ labels, values }) => {
  const data = {
    labels: labels || [],
    datasets: [
      {
        label: 'km/gal',
        borderColor: '#00A36C',
        backgroundColor: 'rgba(0,163,108,0.12)',
        fill: true,
        lineTension: 0.2,
        data: values || [],
      },
    ],
  };
  return (
    <div style={{ height: 245 }}>
      <Line
        data={data}
        options={{
          ...chartOptionsBase,
          scales: {
            yAxes: [{ ticks: { beginAtZero: false } }],
          },
        }}
      />
    </div>
  );
};

FuelLineChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.number),
};

FuelLineChart.defaultProps = {
  labels: [],
  values: [],
};

const STATUS_COLORS = {
  CALCULATED: '#00A36C',
  IN_PROGRESS: '#007bff',
  PENDING_LIQUIDATION: '#17a2b8',
  MISSING_REFILL: '#f0ad4e',
  OVERDUE: '#d9534f',
  OBSERVED: '#6f42c1',
};

export const FuelStatusDonut = ({ slices, onSliceClick }) => {
  const list = slices || [];
  const data = {
    labels: list.map((s) => s.label || s.key),
    datasets: [
      {
        data: list.map((s) => Number(s.count) || 0),
        backgroundColor: list.map(
          (s) => STATUS_COLORS[s.key] || '#6c757d',
        ),
        borderWidth: 0,
      },
    ],
  };
  return (
    <div style={{ height: 245 }}>
      <Doughnut
        data={data}
        options={{
          ...chartOptionsBase,
          cutoutPercentage: 55,
          legend: { display: true, position: 'right' },
          onClick: (event, elements) => {
            if (!onSliceClick || !elements || !elements.length) {
              return;
            }
            const idx = elements[0]._index;
            const slice = list[idx];
            if (slice && slice.key) {
              onSliceClick(slice.key, slice.label);
            }
          },
        }}
      />
    </div>
  );
};

FuelStatusDonut.propTypes = {
  slices: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ),
  onSliceClick: PropTypes.func,
};

FuelStatusDonut.defaultProps = {
  slices: [],
  onSliceClick: null,
};
